import React, { FC, useContext, useMemo } from 'react';
import { SloGroupDTO } from '@atlassiansox/phobos-client-ts';
import ReactJson from 'react-json-view';
import pick from 'lodash/pick';
import SectionMessage from '@atlaskit/section-message';

import { Theme, ThemeContext } from '@/controllers/theme-controller';
import { flex, flexDirectionColumn, extendWidth, spaceTopCozy } from '@/styles';

import { configurationPanelStyles } from './styles';

type ConfigurationPanelProps = {
  data: SloGroupDTO;
};

const ConfigurationPanel: FC<ConfigurationPanelProps> = ({ data }) => {
  const [theme] = useContext(ThemeContext);

  const dataDisplay = useMemo(
    () =>
      pick(data, [
        'name',
        'description',
        'type',
        'goodQueryTemplate',
        'badQueryTemplate',
        'query',
        'objective',
        'lowTrafficThreshold',
        'suppressLowTrafficAlerts',
        'isUltraSteepBurnEnabled',
        'enabledAlerts',
        'detectors',
        'cohorts',
        'manualTag',
        'runbookUrl',
        'serviceId',
        'isDraft',
        'autoSync',
        'sloGroupType',
      ]),
    [data]
  );

  return (
    <div css={[flex, flexDirectionColumn, extendWidth, spaceTopCozy]}>
      <SectionMessage title="Editing from UI is restricted">
        <p>
          Please be noted that editing SLO group configuration from UI is restricted. If you need to
          make changes, please manage the updates from Terraform resource.
        </p>
      </SectionMessage>
      <div css={[spaceTopCozy, configurationPanelStyles]}>
        <ReactJson
          theme={theme === Theme.Dark ? 'google' : 'rjv-default'}
          src={dataDisplay}
          name={false}
          displayObjectSize={false}
          displayDataTypes={false}
          enableClipboard={false}
          iconStyle="square"
          style={{ background: 'inherit' }}
        />
      </div>
    </div>
  );
};

export default ConfigurationPanel;
